import { LoadOptions } from 'app/types-shared';
import { CodeFieldWireKey, CodetableMetadata } from '../../types-store';
import { CodetableTranslation } from '../../constants';
import { CodeItem } from '../types-store';
import { ValidationProps } from 'ui/common/validation/types';
import { CodeActionType } from 'app/area/indicator-factors/item/types';
import { FilterOption } from 'app/components/options-handler/types';
import { LoadCodeItemsParams } from 'app/area/indicator-factors/common';
import { CodeComplexValue } from 'app/area/shared/codetable/types';

interface CodePickerProps {
  breadcrumbs?: number[];
  codetableId?: number;
  codeItem: CodeItem;
  metadata: CodetableMetadata;
  translation: CodetableTranslation;
  readOnly?: boolean;
}

export interface CodeCodetablePickerProps extends CodePickerProps {
  onChange: (field: string, value: CodeComplexValue<number> | Date) => void;
  resetValidation: (field: string, value: CodeComplexValue<number> | Date) => void;
  codetableOptions: {
    [key: string]: {
      fetching: boolean;
      codes: CodeComplexValue<number>[];
      currentOptions: CodeComplexValue<number>[];
      loadOptionsParams?: LoadCodeItemsParams;
    };
  };
  options?: { [key: string]: FilterOption };
  required?: boolean;
  validation?: { [key: string]: ValidationProps };
  locale?: string;
  clearAllValidation?: (codetableKey: CodeFieldWireKey) => void;
  loadCodetableOptions: (id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions,
    optionsParams?: LoadCodeItemsParams) => void;
  loadOptions?: (
    id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
  actionType?: CodeActionType;
}

export enum codePickersId {
  substanceUom = 338,
  substance = 341,
  substanceCategory = 351,
  indicatorType = 343,
  indicatorFactors = 344,
  location = 34,
  source = 331,
  unit = 31,
  equipment = 36,
  environmentalValues = 1087
}

export const selectSize = 4;
